import script from "./PillStyleSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./PillStyleSelection.vue?vue&type=script&setup=true&lang=js"

import "./PillStyleSelection.vue?vue&type=style&index=0&id=89418910&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89418910"]])

export default __exports__